import mixpanel from 'mixpanel-browser';
mixpanel.init(process.env.REACT_APP_AIVO_MIXPANEL_TOKEN, {debug: true});

let env_check = true;

let actions = {
  identify: (id: any) => {
    if (env_check) mixpanel.identify(id);
  },
  track: (name: string, props?: any) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props: any) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
  register: (props: any) => {
    if (env_check) mixpanel.register(props);
  },
};

export let Mixpanel = actions;
